<template>
  <header class="site-header">
    <div class="header-container">
      <div class="header-content">
        <!-- Logo区域 -->
        <div class="logo-section">
          <router-link to="/" class="logo-link">
            <div class="logo">
              <div class="logo-icon">
                <img src="@/assets/logo.png" alt="山东文达检测" class="logo-image" />
              </div>
              <div class="logo-text">
                <h1>山东文达检测</h1>
                <span>专业检验检测服务</span>
              </div>
            </div>
          </router-link>
        </div>

        <!-- 导航菜单 -->
        <nav class="main-nav" v-if="!isMobile">
          <ul class="nav-list">
            <li class="nav-item">
              <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }">
                网站首页
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/about" class="nav-link" :class="{ active: $route.path === '/about' }">
                关于我们
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/news" class="nav-link" :class="{ active: $route.path === '/news' }">
                新闻资讯
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/services" class="nav-link" :class="{ active: $route.path === '/services' }">
                我们的服务
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/testing-center" class="nav-link" :class="{ active: $route.path === '/testing-center' }">
                报告查真伪
              </router-link>
            </li>
          </ul>
        </nav>

        <!-- 操作按钮 -->
        <!-- <div class="header-actions" v-if="!isMobile">
          <el-button type="primary" @click="goToReportList" class="action-btn">
            <el-icon><Monitor /></el-icon>
            管理系统
          </el-button>
        
        </div> -->

        <!-- 移动端菜单按钮 -->
        <el-button 
          class="mobile-menu-btn" 
          type="text" 
          @click="showMobileMenu = !showMobileMenu"
          v-if="isMobile"
        >
          <el-icon><Menu /></el-icon>
        </el-button>
      </div>

      <!-- 移动端菜单 -->
      <div v-if="isMobile && showMobileMenu" class="mobile-menu">
        <div class="mobile-nav">
          <router-link to="/" class="mobile-nav-link" @click="closeMobileMenu">网站首页</router-link>
          <router-link to="/about" class="mobile-nav-link" @click="closeMobileMenu">关于我们</router-link>
          <router-link to="/news" class="mobile-nav-link" @click="closeMobileMenu">新闻资讯</router-link>
          <router-link to="/services" class="mobile-nav-link" @click="closeMobileMenu">我们的服务</router-link>
          <router-link to="/testing-center" class="mobile-nav-link" @click="closeMobileMenu">检测中心</router-link>
        </div>
        <div class="mobile-actions">
          <!-- <el-button type="primary" @click="goToReportList" class="mobile-action-btn">
            <el-icon><Monitor /></el-icon>
            管理系统
          </el-button> -->
          <!-- 上传报告按钮已移除 -->
          <!-- <el-button @click="goToUpload" class="mobile-action-btn outline">
            <el-icon><Upload /></el-icon>
            上传报告
          </el-button> -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { Document, Monitor, /* Upload, */ Menu } from '@element-plus/icons-vue'

export default {
  name: 'Header',
  components: {
    Document,
    Monitor,
    // Upload, // 已移除
    Menu
  },
  setup() {
    const router = useRouter()
    const showMobileMenu = ref(false)
    const windowWidth = ref(window.innerWidth)

    const isMobile = computed(() => windowWidth.value < 768)

    const handleResize = () => {
      windowWidth.value = window.innerWidth
      if (!isMobile.value) {
        showMobileMenu.value = false
      }
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })

    const goToReportList = () => {
      router.push('/ReportList')
      showMobileMenu.value = false
    }

    // 上传报告方法已移除
    // const goToUpload = () => {
    //   router.push('/upload')
    //   showMobileMenu.value = false
    // }

    const closeMobileMenu = () => {
      showMobileMenu.value = false
    }

    return {
      showMobileMenu,
      isMobile,
      goToReportList,
      // goToUpload, // 已移除
      closeMobileMenu
    }
  }
}
</script>

<style scoped>
.site-header {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

/* Logo区域 */
.logo-section {
  flex-shrink: 0;
}

.logo-link {
  text-decoration: none;
  color: inherit;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  overflow: hidden;
}

.logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 12px;
}

.logo-text h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: white;
  line-height: 1.2;
}

.logo-text span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  display: block;
  margin-top: 2px;
}

/* 导航菜单 */
.main-nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 40px;
}

.nav-item {
  position: relative;
}

.nav-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  padding: 10px 0;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover,
.nav-link.active {
  color: #4facfe;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #4facfe, #00f2fe);
  transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.active::after {
  width: 100%;
}

/* 操作按钮 */
.header-actions {
  display: flex;
  gap: 15px;
  flex-shrink: 0;
}

.action-btn {
  height: 42px;
  padding: 0 20px;
  border-radius: 21px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.action-btn.outline {
  background: transparent;
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
}

.action-btn.outline:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: #4facfe;
  color: #4facfe;
}

/* 移动端菜单 */
.mobile-menu-btn {
  color: white;
  font-size: 24px;
  padding: 8px;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px;
  box-shadow: 0 8px 32px rgba(30, 60, 114, 0.3);
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.mobile-nav-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-weight: 500;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: color 0.3s ease;
}

.mobile-nav-link:hover,
.mobile-nav-link.router-link-active {
  color: #4facfe;
}

.mobile-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mobile-action-btn {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  font-weight: 500;
}

.mobile-action-btn.outline {
  background: transparent;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    height: 70px;
  }
  
  .logo-text h1 {
    font-size: 20px;
  }
  
  .logo-text span {
    font-size: 11px;
  }
  
  .logo-icon {
    width: 45px;
    height: 45px;
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .header-container {
    padding: 0 15px;
  }
  
  .logo {
    gap: 8px;
  }
  
  .logo-text h1 {
    font-size: 18px;
  }
  
  .logo-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
}
</style>